<template>
  <div style="width: 100%">
    <router-link :to="url" v-slot="{href}">
      <fin-entity-card
        :height="itemHeight"
        :href="href"
        :show-background="showBackground"
        :show-bookmark="showBookmark"
        :show-border="showBorder"
        :show-box-shadow="showBoxShadow"
        :width="width"
      >
        <template #content>
          <v-row ref="content"
                 :class="'item-row mx-0 ' + (largeCard ? '' : ($vuetify.breakpoint.xs ? 'px-3' : 'px-6'))">
            <v-col v-if="value.teaserThumbnailUrl && !hideThumbnail"
                   :class="'px-0 ' + (largeCard && !hideThumbnail && value.teaserThumbnailUrl ? 'col-xl-2 col-lg-2 col-md-4 col-sm-5 pl-0' : '')"
                   cols="12">
              <v-img ref="picture" :aspect-ratio="16/9" :src="value.teaserThumbnailUrl" class="pr-3"
                     style="display: inline-block; vertical-align: top; width: 100%">
                <v-container fill-height fluid ma-0 slot="placeholder">
                  <v-row justify="center" align="center">
                    <fin-logo-full dark loading></fin-logo-full>
                  </v-row>
                </v-container>
              </v-img>
            </v-col>

            <v-col cols="12"
                   :class="'px-0 item-row-col-text ' + (largeCard && !hideThumbnail && value.teaserThumbnailUrl && $vuetify.breakpoint.smAndUp ? 'col-xl-6 col-lg-7 col-md-6 col-sm-7' : '')">
              <fin-news-item-source-date-category :value="value"/>
              <p v-if="showItemTitle" class="mb-2 news-title">
                {{ value.title | truncate(truncatedTitleLength) }}
              </p>
              <!-- false because teaserText contains the same as title -->
              <p v-if="showItemTeaser && false" class="news-teaser">
                {{ value.teaserText | truncate(truncatedTeaserLength) }}
              </p>
              <div v-if="showItemTeaser" class="news-teaser news-teaser-truncated" v-html="value.content"/>
              <v-divider v-if="showDivider"/>
            </v-col>
          </v-row>
        </template>
      </fin-entity-card>
    </router-link>
  </div>
</template>

<script>
import finEntityCard from '@/components/common/FinEntityCard'
import finLogoFull from '@/components/common/logo/LogoFull/index'
import FinNewsItemSourceDateCategory from './NewsItemSourceDateCategory'

export default {
  name: 'fin-news-item',
  components: {FinNewsItemSourceDateCategory, finEntityCard, finLogoFull},
  data() {
    return {
      itemHeight: undefined,
      hideThumbnail: process.env.VUE_APP_HIDE_NEWS_THUMBNAILS === 'true' || this.hideImage
    }
  },
  props: {
    value: {
      type: Object
    },
    hideImage: {
      type: Boolean
    },
    width: {
      type: Number,
      default: undefined
    },
    /** if you want to set a specific height, set the property fixedItemHeight (for example when displaying news items in a carousel).
     * If fixedItemHeight is not set, the height will be calculated. */
    fixedItemHeight: {
      type: Number,
      default: undefined
    },
    showBookmark: {
      type: Boolean,
      default: false
    },
    /** The layout of a large card contains two columns:
     *      on the left: image
     *      on the right: source-datum-category, title, teaser
     * The layout of a 'normal' card contains one column
     *      source-datum-category, image, title, teaser
     * */
    largeCard: {
      typ: Boolean,
      default: false
    },
    /** set to true to display the title */
    showItemTitle: {
      typ: Boolean,
      default: true
    },
    /** set to true to display the teaser */
    showItemTeaser: {
      typ: Boolean,
      default: true
    },
    /** set to true to display the shadow of the card */
    showBoxShadow: {
      typ: Boolean
    },
    /** set to true to display the border of the card */
    showBorder: {
      typ: Boolean
    },
    /** set to true to display the background of the card */
    showBackground: {
      typ: Boolean
    },
    /** set to true to display the divider after the item */
    showDivider: {
      typ: Boolean,
      default: true
    }
  },
  methods: {
    /** if fixedItemHeight is set, the itemHeight will be set to this value. Otherwise the height will be calculated */
    calcItemHeight() {
      if (this.fixedItemHeight !== undefined) {
        this.itemHeight = this.fixedItemHeight
      } else {
        let contentHeight = 0
        if (this.$refs.content) {
          contentHeight += this.$refs.content.clientHeight
        }
        if (this.$refs.picture) {
          contentHeight += this.$refs.picture.clientHeight
        }
        this.itemHeight = contentHeight
      }
    },
    handleResize() {
      this.calcItemHeight()
    }
  },
  computed: {
    truncatedTitleLength() {
      // TODO global variable
      return 250
    },
    truncatedTeaserLength() {
      // TODO global variables
      return this.hideThumbnail ? 170 : 250
    },
    url() {
      return {name: 'newsDetail', params: {id: this.value.id}}
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  }
}
</script>

<style lang="scss" scoped>
a {
  &:link, &:visited, &:hover, &:active {
    text-decoration: none;
  }
}

.news-title {
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 22px;
  letter-spacing: normal;
  margin-bottom: 8px;

  @media only screen and (max-width: 960px) {
    font-size: 1.1em;
  }
}

.news-teaser, .news-text {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 21px;
  letter-spacing: normal;
}

::v-deep .news-teaser-truncated {
  width: 100%;
  max-height: 30px;
  overflow: hidden;
  white-space: nowrap;

  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

  }
}
</style>
